import exp from "constants"

export const contractAddresses: any = {
    1: {
        ETH: '0x77b2043768d28E9C9aB44E1aBfC95944bcE57931',
        USDC: '0xc026395860Db2d07ee33e05fE50ed7bD583189C7',
        USDT: '0x6c96de32cea08842dcc4058c14d3aaad7fa41dee',
        SBTC: '0x3f690f43a9fCA689829A22bf925c89B7a48ca57F',
        SOLVBTC: '0xB12979Ff302Ac903849948037A51792cF7186E8e',
        ['SOLVBTC.BBN']: '0x94DaBd84Cd36c4D364FcDD5CdABf41E73dBc99e6',
        USDE: '0x5d3a1Ff2b6BAb83b63cd9AD0787074081a52ef34',
        SUSDE: '0x211Cc4DD073734dA055fbF44a2b4667d5E5fE5d2',
        // ['PUMPBTC.BERA']: '0xADc9c900b05F39f48bB6F402A1BAE60929F4f9A8',
        LBTC: '0x1290A6b480f7eF14925229fdB66f5680aD8F44AD',
        FBTC: '0x0b835f07a2a54C0e80c1F585e5b6Dd732816dA3F',
        RSWETH: '0x1486D39646cdee84619bd05997319545A8575079',
        RSETH: '0x85d456B2DfF1fd8245387C0BfB64Dfb700e98Ef3',
        WEETH: '0xcd2eb13d6831d4602d80e5db9230a57596cdca63',
        WBTC: '0x0555E30da8f98308EdB960aa94C0Db47230d2B9c',
        PYUSD: '0x688e72142674041f8f6Af4c808a4045cA1D6aC82',
        USDA: '0x8A60E489004Ca22d775C5F2c657598278d17D9c2',
        SUSDA: '0x2b66aade1e9c062ff411bd47c44e0ad696d43bd9',
        RUSD: '0xf0e9f6d9ba5d1b3f76e0f82f9dcdb9ebeef4b4da',
        WABTC: '0x37016812a5c2c54793fd277b7f75086a47377d28',

        // disbaled
        STBTC: '',
    },
    80094: {
        WETH: '0x45f1A95A4D3f3836523F5c83673c797f4d4d263B',
        ['USDC.E']: '0xAF54BE5B6eEc24d6BFACf1cce4eaF680A8239398',
        ['USD₮0']: '0x3Dc96399109df5ceb2C226664A086140bD0379cB',
        SBTC: '0x2B1D947f995Cdad9eE38AED2096C75fcbB47Ec8D',
        SOLVBTC: '0xB12979Ff302Ac903849948037A51792cF7186E8e',
        ['SOLVBTC.BBN']: '0x94DaBd84Cd36c4D364FcDD5CdABf41E73dBc99e6',
        USDE: '0x5d3a1Ff2b6BAb83b63cd9AD0787074081a52ef34',
        SUSDE: '0x211Cc4DD073734dA055fbF44a2b4667d5E5fE5d2',
        // ['PUMPBTC.BERA']: '0xADc9c900b05F39f48bB6F402A1BAE60929F4f9A8',
        LBTC: '0x630e12D53D4E041b8C5451aD035Ea841E08391d7',
        FBTC: '0x0b835f07a2a54C0e80c1F585e5b6Dd732816dA3F',
        RSWETH: '0x850CDF416668210ED0c36bfFF5d21921C7adA3b8',
        RSETH: '0x4186BFC76E2E237523CBC30FD220FE055156b41F',
        WEETH: '0x7DCC39B4d1C53CB31e1aBc0e358b43987FEF80f7',
        WBTC: '0x0555E30da8f98308EdB960aa94C0Db47230d2B9c',
        PYUSD: '0x688e72142674041f8f6Af4c808a4045cA1D6aC82',
        USDA: '0xff12470a969dd362eb6595ffb44c82c959fe9acc',

        SUSDA: '0x2840F9d9f96321435Ab0f977E7FDBf32EA8b304f',
        RUSD: '0x09d4214c03d01f49544c0448dbe3a27f768f2b34',
        WABTC: '0x09DEF5aBc67e967d54E8233A4b5EBBc1B3fbE34b',

        // disbaled
        STBTC: '',
        UNIBTC: '',
    },
    42161: {
        ETH: '0xa45b5130f36cdca45667738e2a258ab09f4a5f7f',
        USDC: '0xe8cdf27acd73a434d661c84887215f7598e7d0d3',
        ['USDT']: '0x14e4a1b13bf7f943c8ff7c51fb60fa964a298d92'
    },
    8453: {
        ETH: '0xdc181bd607330aeebef6ea62e03e5e1fb4b6f7c7',
        USDC: '0x27a16dc786820b16e5c9028b75b99f6f604b5d26',
        WEETH: '0x04c0599ae5a44757c0af6f9ec3b93da8976c150a',
        WBTC: '0x0555e30da8f98308edb960aa94c0db47230d2b9c'
    },
    56: {
        USDC: '0x962Bd449E630b0d928f308Ce63f1A21F02576057',
        WEETH: '0x04c0599ae5a44757c0af6f9ec3b93da8976c150a',
        WBTC: '0x0555e30da8f98308edb960aa94c0db47230d2b9c'
    },
    43114: {
        WBTC: '0x0555e30da8f98308edb960aa94c0db47230d2b9c',
        USDC: '0x5634c4a5FEd09819E3c46D86A965Dd9447d86e47'
    },
    59144: {
        ETH: '0x81f6138153d473e8c5ecebd3dc8cd4903506b075'
    },
    5000: {
        WETH: '0x4c1d3Fc3fC3c177c3b633427c2F769276c547463',
        USDC: '0xac290ad4e0c891fdc295ca4f0a6214cf6dc6acdc'
    },
    10: {
        ETH: '0xe8cdf27acd73a434d661c84887215f7598e7d0d3',
        USDC: '0xcE8CcA271Ebc0533920C83d39F417ED6A0abB7D0'
    },
    137: {
        USDC: '0x9Aa02D4Fae7F58b8E8f34c66E756cC734DAc7fe4'
    },
    534352: {
        ETH: '0xc2b638cb5042c1b3c5d5c969361fb50569840583',
        USDC: '0x3Fc69CC4A842838bCDC9499178740226062b14E4'
    }
}


export const chainIds: any = {
    1: 30101,
    80094: 30362,
    42161: 30110,
    8453: 30184,
    5000: 30181,
    43114: 30106,
    56: 30102,
    59144: 30183,
    1088: 30151,
    10: 30111,
    137: 30109,
    1101: 30177,
    324: 30210,
    100: 30124,
    169: 30225,
    534352: 30214,
    81457: 30194,
    34443: 30234
}

export const tokenPairs: any = {
    1: {
        'ETH': 'WETH',
        'USDC': 'USDC.E',
        'USDT': 'USD₮0',
        'SBTC': 'SBTC',
        'SOLVBTC': 'SOLVBTC',
        'USDE': 'USDE',
        'SUSDE': 'SUSDE',
        'SOLVBTC.BBN': 'SOLVBTC.BBN',
        // 'PUMPBTC.BERA': 'PUMPBTC.BERA',
        'LBTC': 'LBTC',
        'FBTC': 'FBTC',
        'RSWETH': 'RSWETH',
        'RSETH': 'RSETH',
        'WEETH': 'WEETH',
        'WBTC': 'WBTC',
        'PYUSD': 'PYUSD',
        'USDA': 'USDA',
        'SUSDA': 'SUSDA',
        'RUSD': 'RUSD',
        'WABTC': 'WABTC',

        // disabled
        STBTC: 'STBTC',
        UNIBTC: 'UNIBTC',
    },
    80094: {
        'WETH': 'ETH',
        'USDC.E': 'USDC',
        'USD₮0': 'USDT',
        'SBTC': 'SBTC',
        'SOLVBTC': 'SOLVBTC',
        'USDE': 'USDE',
        'SUSDE': 'SUSDE',
        'SOLVBTC.BBN': 'SOLVBTC.BBN',
        // 'PUMPBTC.BERA': 'PUMPBTC.BERA',
        'LBTC': 'LBTC',
        'FBTC': 'FBTC',
        'RSWETH': 'RSWETH',
        'RSETH': 'RSETH',
        'WEETH': 'WEETH',
        'WBTC': 'WBTC',
        'PYUSD': 'PYUSD',
        'USDA': 'USDA',
        'SUSDA': 'SUSDA',
        'RUSD': 'RUSD',
        'WABTC': 'WABTC',

        // disabled
        STBTC: 'STBTC',
        UNIBTC: 'UNIBTC',
    },
    42161: {
        'ETH': 'WETH',
        'USDC': 'USDC.E',
        'USDT': 'USD₮0',
    },
    8453: {
        'ETH': 'WETH',
        'USDC': 'USDC.E',
        'WEETH': 'WEETH',
        'WBTC': 'WBTC'
    },
    56: {
        'USDC': 'USDC.E',
        'WEETH': 'WEETH',
        'WBTC': 'WBTC'
    },
    43114: {
        'WBTC': 'WBTC',
        'USDC': 'USDC.E',
    },
    59144: {
        'ETH': 'WETH',
    },
    5000: {
        'WETH': 'WETH',
        'USDC': 'USDC.E',
    },
    10: {
        'ETH': 'WETH',
        'USDC': 'USDC.E',
    },
    137: {
        'USDC': 'USDC.E',
    },
    534352: {
        'ETH': 'WETH',
        'USDC': 'USDC.E',
    }
}

export const tokenParams: any = {
    LBTC: '0x00030100110100000000000000000000000000030d40',
    USDA: '0x00030100110100000000000000000000000000030d40',
    SUSDA: '0x00030100110100000000000000000000000000030d40',
    WABTC: '0x00030100110100000000000000000000000000030d40'
}